import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/free-solid-svg-icons'
import Username from './../common/Username';
import Avatar from './../common/Avatar';
import { Link } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css'

const ActivityFeedScreenshot = (props) => (
    <li className="media">
        <div className="row">
            <div className="col-xs-2">
                <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
            </div>
            <div className="col-xs-10">
                <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
                <span className="activity-date text-muted"> uploaded an image, </span>
                <Link to={"/screenshots/"+props.item.screenshot.slug}>"{props.item.screenshot.title}"</Link>
                <div className="media-left">
                    <FontAwesomeIcon className="text-primary" icon={faImage} fixedWidth />
                </div>
                <div className="media-body">
                    <Zoom
                        overlayBgColorStart='rgba(0, 0, 0, 0.7)'
                        overlayBgColorEnd='rgba(0, 0, 0, 0.7)'
                        zoomMargin={40}
                    >
                    <img
                        src={props.item.screenshot.image}
                        alt={props.item.screenshot.title}
                        className='adt-gallery-image'
                        /> 
                    </Zoom>
                </div>
            </div>
        </div>
    </li>
);

export default ActivityFeedScreenshot;


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedScreenshot.js